import React, { Fragment } from "react";
import _ from "lodash";
import styled from "styled-components";
import { Grid, TextField, FormHelperText } from '@material-ui/core';
import { withStyles } from "@material-ui/core/styles";
import SectionHeader from './SectionHeader';
import inputComponentMask from "lib/inputMask";
import numberFormatter from 'utils/numberFormatter'
import unitAssetTypes from 'constants/unitAssetTypes';
import ConfigItemSelect from './ConfigItemSelect';
import PercentInput from './PercentInput';
import StandardNumberInput from './StandardNumberInput';
import { UnstyledDateField } from "components/Global/Fields/Date";
const styles = theme => ({
  firstAssetTypeControl: {
    minWidth:200
  },
  assetTypeControl: {    
    width:'100%',
    marginTop: '10px'
  },
  assetClassControl: {    
    width:'100%',
    marginTop: '10px'
  },
  marketValueMethodologyControl: {
    width:'100%',
    marginTop: '10px'
  },
  zoning: {    
    width:'100%',
    marginTop: '10px'
  },
  labelRoot: {
    fontSize: '17px'
  },
  inputField: {
    borderBottom: '1px solid #2196F3',
        
  },
  error: {
    '& input':{
       borderBottom: '1px solid red'
    }
  }  
})
const ComputedLabel = styled.span`
  color: #999;
  padding-right:4px;
  padding-top:4px;
`;
const ComputedValue = styled.span`
  color: #999;  
  padding-top:4px;
`;
const ComputedField = ({label, value}) => {  
  return (
    <Fragment>
      <ComputedLabel>{label}:</ComputedLabel>
      <ComputedValue>{value}</ComputedValue>
    </Fragment>
  )
}

const DateFieldWrapper = styled.div`
 & div:first-child {
   width:100%;
 }
 & label {
   font-size:17px;
 }
 &&&&& div div::before {
  border-bottom: 1px solid #2196F3;
  }
  &&&&& div div:hover::before {
    border-bottom: 1px solid #2196F3;
  }
  &&&&& div div::after {
    border-bottom: 1px solid #006dab;
  }
`;

class GeneralInfo extends React.Component {

  getAverageUnitSquareFeet = values => {
    if(!values.units)
      return 0;
    let result = values.squareFeet / values.units;
    return numberFormatter.formatDecimal(result,0);
  }
  getDensity = values => {
    if(!values.landSize)
      return 0;
    let result =  values.units / values.landSize;
    return numberFormatter.formatDecimal(result,1);
  }
  shouldShowAverageUnitSquareFeet = values => {
    return values.units && values.squareFeet;
  }
  shouldShowDensity = values => {
    return values.units && values.landSize;
  }
  shouldShowUnits = values => {
    let assetTypeId = values.assetTypeId;
    if(!assetTypeId)
      return false;
    return unitAssetTypes.hasOwnProperty(assetTypeId);
  }
  renderAssetTypeIfNotSet = (errors, values, handleChange, assetTypeOptions, classes) => {
    if(values.assetTypeId)
      return null;
    return (
      <ConfigItemSelect
        id = "assetTypeDropdown"        
        required
        error={errors.assetTypeId}
        values={values}
        handleChange={handleChange}
        label="Asset Type *"
        options={assetTypeOptions}
        fieldName="assetTypeId"
        rootClassName={classes.firstAssetTypeControl}
      />
    );
  }

  render(){
    const {handleChange, handleBlur,values,errors, touched} = this.props; //formik props
    const { assetTypeOptions, assetClassOptions, zoningOptions, classes, marketValueMethodologyOptions } = this.props;
    return (
      <div>
        <SectionHeader>General Info</SectionHeader>       
        {this.renderAssetTypeIfNotSet(errors, values, handleChange, assetTypeOptions, classes)}
        {values.assetTypeId && <div>
        <Grid container direction="row" spacing={16}>
          <Grid item xs={6}>
            <TextField
              InputProps={{
                classes:{                  
                  input:classes.inputField,
                  error: classes.error
                },
                disableUnderline:true,
              }}        
              InputLabelProps={{
                FormLabelClasses: {
                  root: classes.labelRoot
                }
              }}      
              fullWidth
              required
              error={!!errors.name && touched.name}
              id="name"              
              label="Property Name"
              value={values.name}
              onChange={handleChange}
              onBlur={handleBlur}/>
            {!!errors.name && <FormHelperText>{errors.name}</FormHelperText>}
          </Grid>
          <Grid item xs={4}>
            <ConfigItemSelect
              required
              error={errors.assetTypeId}
              values={values}
              handleChange={handleChange}
              label="Asset Type *"
              id="assetTypeDropdown"
              options={assetTypeOptions}
              fieldName="assetTypeId"
              rootClassName={classes.assetTypeControl}
            />
          </Grid>
          <Grid item xs={2}>
            <ConfigItemSelect
              values={values}
              handleChange={handleChange}
              label="Class"
              id="classDropdown"
              options={assetClassOptions}
              fieldName="assetClassId"
              rootClassName={classes.assetClassControl}/>      
          </Grid>     
        </Grid>
        <Grid container direction="row" spacing={16}>
          <Grid item xs={3}>
            <TextField              
              fullWidth
              label="NOI (Lender)"      
              id="noiField"        
              type="text"              
              name="noi"
              value={values.noi || ''}
              onChange={handleChange}
              InputLabelProps={{
                FormLabelClasses: {
                  root: classes.labelRoot
                }
              }}     
              InputProps={{
                classes:{
                  root: classes.inputRoot,
                  input:classes.inputField
                },
                disableUnderline:true,
                inputComponent: inputComponentMask({
                  mask: "currency"
              })}}/>
          </Grid>
          <Grid item xs={3}>
            <TextField              
              fullWidth
              label="NOI (Actual)"      
              id="noiActualField"        
              type="text"              
              name="noiActual"
              value={values.noiActual || ''}
              onChange={handleChange}
              InputLabelProps={{
                FormLabelClasses: {
                  root: classes.labelRoot
                }
              }}     
              InputProps={{
                classes:{
                  root: classes.inputRoot,
                  input:classes.inputField
                },
                disableUnderline:true,
                inputComponent: inputComponentMask({
                  mask: "currency"
              })}}/>
          </Grid>
          <Grid item xs={3}>
            <PercentInput 
              fullWidth
              classes={classes}
              label="Occupancy"
              fieldName="occupancy"   
              id="occupancyField"           
              values={values}              
              handleChange={handleChange}/>
          </Grid>
          <Grid item xs={3}>
            <DateFieldWrapper>
              <UnstyledDateField
                label="As of Date"
                name="noiAsOfDate"
                clearable
                value={values.noiAsOfDate}
              />
            </DateFieldWrapper>
          </Grid>
        </Grid>

        <Grid container direction="row" spacing={16}>
          <Grid item xs={3}>
            <TextField              
              label="Market Value"              
              type="text"              
              id="marketValue"
              value={values.marketValue || ''}
              onChange={handleChange}
              InputLabelProps={{
                FormLabelClasses: {
                  root: classes.labelRoot
                }
              }}     
              InputProps={{
                classes:{
                  root: classes.inputRoot,
                  input:classes.inputField
                },
                disableUnderline:true,
                inputComponent: inputComponentMask({
                  mask: "currency"
                })
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <DateFieldWrapper>
              <UnstyledDateField
                label="As of Date"
                name="marketValueAsOfDate"
                clearable
                value={values.marketValueAsOfDate}
              />
            </DateFieldWrapper>
          </Grid>
          <Grid item xs={4}>
            <ConfigItemSelect
              values={values}
              handleChange={handleChange}
              label="Methodology"
              id="marketValueMethodologyDropdown"
              options={marketValueMethodologyOptions}
              fieldName="marketValueMethodologyId"
              rootClassName={classes.marketValueMethodologyControl}
            />
          </Grid> 
        </Grid>

        <Grid container direction="row" spacing={16}>
          <Grid item xs={3}>
            <TextField              
              label="Appraised Value"              
              type="text"              
              id="appraisedValue"
              value={values.appraisedValue || ''}
              onChange={handleChange}
              InputLabelProps={{
                FormLabelClasses: {
                  root: classes.labelRoot
                }
              }}     
              InputProps={{
                classes:{
                  root: classes.inputRoot,
                  input:classes.inputField
                },
                disableUnderline:true,
                inputComponent: inputComponentMask({
                  mask: "currency"
                })}}/>
          </Grid>
          <Grid item xs={3}>
            <DateFieldWrapper>
              <UnstyledDateField
                label="As of Date"
                name="appraisedValueAsOfDate"
                clearable
                value={values.appraisedValueAsOfDate}
              />
            </DateFieldWrapper>
          </Grid>
        </Grid>

        
        
        <Grid container direction="row" spacing={16}>
          <Grid item xs={3}>
            <ConfigItemSelect
              disableUnderline={true}
              values={values}
              handleChange={handleChange}
              label="Zoning"
              options={zoningOptions}
              fieldName="zoningId"
              id="zoningDropdown"
              rootClassName={classes.zoning}/>    
          </Grid>
          <Grid item xs={3}>
            <StandardNumberInput
              fullWidth              
              classes={classes}
              label="Square Feet"                              
              fieldName="squareFeet"
              id="squareFeetField"
              values={values}
              handleChange={handleChange}/>
          </Grid>
          <Grid item xs={3}>
            <StandardNumberInput
              fullWidth
              classes={classes}
              label="Land Size"
              id="landSizeField"
              fieldName="landSize"
              values={values}              
              handleChange={handleChange}/>
          </Grid>
          {this.shouldShowUnits(values) &&
          <Grid item xs={3}>
            <StandardNumberInput
              fullWidth
              classes={classes}
              label="Units"
              fieldName="units"        
              id="unitsField"      
              values={values}
              handleChange={handleChange}/>
          </Grid>
          }
        </Grid>
        <Grid container direction="row" spacing={16}>
          <Grid item xs={3}>
            <div></div>
          </Grid>
          <Grid item xs={3}>
            {this.shouldShowAverageUnitSquareFeet(values) && this.shouldShowUnits(values) &&
            <ComputedField label={'Average Unit SF (square ft/units)'} value={this.getAverageUnitSquareFeet(values)}/>
            }
          </Grid>
          <Grid item xs={3}>
            {this.shouldShowDensity(values) && this.shouldShowUnits(values) &&
            <ComputedField label={'Density (units/acre)'} value={this.getDensity(values)}/>
            }
          </Grid>
        </Grid>
        </div>}
      </div>
    )
  }
}

export default withStyles(styles)(GeneralInfo);
